<script lang="ts" setup>
import type { Housing } from '~/models/Housing';

const url = useRequestURL();

const props = defineProps({
  housing: {
    type: Object as PropType<Housing>,
    required: true,
  },
});

defineOptions({
  inheritAttrs: false,
});

const link = computed(() => `${url.hostname}${uriFromHousing(props.housing)}`);
</script>

<template>
  <tw-share-ad-modal :is-mobile="true" :link="link">
    <template #trigger="{ toggle, attrs }">
      <slot name="button" :toggle="toggle" :attrs="attrs">
        <TwUiAction :is="'button'" type="button" variant="text" class="button" v-bind="attrs" @click="toggle">
          <slot>
            <Icon name="bi:share" />
            {{ $t('share_ad.share') }}
          </slot>
        </TwUiAction>
      </slot>
    </template>
  </tw-share-ad-modal>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/tw-form.scss';

.button {
  gap: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  text-transform: uppercase;
}
</style>
